module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header-top flex items-end justify-between"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "intro"
  }, [_vm._v("Trang thông tin điện tử tổng hợp")])])]), _vm._m(0), _c('div', {
    staticClass: "flex items-end"
  }, [_c('div', {
    staticClass: "date caps mr3"
  }, [_vm._v(_vm._s(_vm.curDate))]), (_vm.isLogin) ? [_c('span', {
    staticClass: "user-name truncate",
    attrs: {
      "title": _vm.userName
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _c('ul', {
    staticClass: "person-panel"
  })] : [_c('el-button', {
    staticClass: "button-login",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleFB
    }
  }, [_vm._v("Login via Facebook")])]], 2)], 1), _c('nav', {
    style: ({
      height: _vm.navHeight
    })
  }, [_c('ul', {
    staticClass: "nav-list my0 list-reset flex",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticClass: "more",
    on: {
      "click": _vm.handleMore
    }
  }), _vm._l((_vm.navList), function(item, idx) {
    return _c('router-link', {
      key: idx,
      staticClass: "truncate",
      class: parseInt(_vm.$route.query.id) === item.cid ? 'active' : !_vm.$route.query.id && idx === 0 ? 'active' : '',
      attrs: {
        "to": idx === 0 ? {
          path: '/'
        } : {
          path: '/',
          query: {
            id: item.cid
          }
        },
        "tag": "li"
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "download",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.xb.topnews&pid=news_official&c=news_official",
      "alt": "VN Ngày Nay",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "download-googleplay"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86aaf0ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 999
// module chunks = 1